import React, {useEffect } from "react";

const DAYS = [
  { day: 1, model: "HRRR" },
  { day: 2, model: "HRRR" },
  { day: 3, model: "GFS" },
  { day: 4, model: "GFS" },
  { day: 5, model: "GFS" },
  { day: 6, model: "GFS" },
  { day: 7, model: "GFS" },
];

export const ForecastSelector = ({ selection, onChange }) => {
  const { day: selectedDay } = selection || {};

  const currentIndex = DAYS.findIndex(d => d.day === selectedDay);

  const handleSelect = (item) => {
    onChange({ model: item.model, day: item.day });
  };

  const goPrev = () => {
    if (currentIndex > 0) {
      handleSelect(DAYS[currentIndex - 1]);
    }
  };

  const goNext = () => {
    if (currentIndex < DAYS.length - 1) {
      handleSelect(DAYS[currentIndex + 1]);
    }
  };

//   const handleKeyDown = (e) => {
//     if (e.key === "ArrowLeft") {
//       e.preventDefault();
//       goPrev();
//     }

//     if (e.key === "ArrowRight") {
//       e.preventDefault();
//       goNext();
//     }
//   };


  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ignore if user typing in inputs
      const tag = document.activeElement?.tagName;
      if (tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT") return;

      if (e.key === "ArrowLeft") {
        e.preventDefault();
        goPrev();
      }

      if (e.key === "ArrowRight") {
        e.preventDefault();
        goNext();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [currentIndex]);

  return (
    <div className="surface--card" style={{ padding: "12px" }}>
      <h4 style={{ marginBottom: "10px" }}>Forecast Day</h4>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <button
          type="button"
          className="button--outline"
          disabled={currentIndex <= 0}
          onClick={goPrev}
        >
          ◀
        </button>

        <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
          {DAYS.map((item) => {
            const isSelected = selectedDay === item.day;

            const baseClass =
              item.model === "HRRR"
                ? "button--hrrr"
                : "button--gfs";

            return (
              <button
                key={item.day}
                type="button"
                aria-pressed={isSelected}
                className={isSelected ? baseClass : "button--outline"}
                style={{ minWidth: "42px" }}
                onClick={() => handleSelect(item)}
              >
                {item.day}
              </button>
            );
          })}
        </div>

        <button
          type="button"
          className="button--outline"
          disabled={currentIndex >= DAYS.length - 1}
          onClick={goNext}
        >
          ▶
        </button>
      </div>
            <div style={{ marginTop: "10px", fontSize: "0.85rem", opacity: 0.8 }}>
        <span style={{ color: "#3b82f6", marginRight: "10px" }}>
          ■ HRRR (Days 1–2)
        </span>
        <span style={{ color: "#ef4444" }}>
          ■ GFS (Days 3–7)
        </span>
      </div>
    </div>
  );
};